import {put} from 'redux-saga/effects';
import config from '../../config';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';

const loadContractPartnerSearchResults = function* loadContractPartnerSearchResults({payload}) {
    const {location} = payload;
    const searchQueryParams = new URLSearchParams(location.search);
    searchQueryParams.append('sort', 'name,asc');
    searchQueryParams.append('size', `${config.DEFAULT_PAGE_SIZE}`);
    // include restrictions: get activeRestrictions and lastRestrictionType
    searchQueryParams.append('includeRestrictions', true);

    yield put({
        type: contractPartnerActionTypes.SEARCH_CONTRACT_PARTNERS,
        payload: {searchQueryParams},
    });
};

export default loadContractPartnerSearchResults;
